import { type Media } from '~/models/media'
import type { OptionInterface } from '~/components/base/controls/use-input'

export enum MarketplaceProductEntityType {
  User = 'user',
  Company = 'company',
}

export const MARKETPLACE_PRODUCT_ENTITY_TYPE_OPTIONS: Readonly<
  OptionInterface[]
> = enumToOptions(MarketplaceProductEntityType, false)

export const MarketplaceProductEntityTypeMap = optionsToMap(
  MARKETPLACE_PRODUCT_ENTITY_TYPE_OPTIONS
)

export class MarketplaceMeta {
  title = ''
  description = ''
  keywords = ''
}

export enum MarketplacePropertyType {
  String = 1,
  Number,
  Array,
}

export const MARKETPLACE_PROPERTY_TYPE_OPTIONS: Readonly<OptionInterface[]> =
  enumToOptions(MarketplacePropertyType)
export const MarketplacePropertyTypeMap = optionsToMap(
  MARKETPLACE_PROPERTY_TYPE_OPTIONS
)

export interface MarketplaceProperty {
  id: number
  title: string
  type: MarketplacePropertyType
  values: string[] | null
  //   groups: MarketplaceGroup[]
}

export interface MarketplaceGroup {
  id: number
  active: boolean
  title: string
  parent_id?: number
  properties: MarketplaceProperty[]
}

export interface MarketplaceCategory {
  category_id: number
  category_name: string
}

export enum MarketplaceProductPriceType {
  Original = 1,
  Discount,
}

export const MARKETPLACE_PRODUCT_PRICE_TYPE_OPTIONS: Readonly<
  OptionInterface[]
> = enumToOptions(MarketplaceProductPriceType)
export const MarketplaceProductPriceTypeMap = optionsToMap(
  MARKETPLACE_PRODUCT_PRICE_TYPE_OPTIONS
)

export interface MarketplaceProductPrice {
  id: number
  product_id: number
  type: MarketplaceProductPriceType
  currency: string
  value: number
}

export interface MarketplaceProductProperty {
  id?: number
  property_id: number
  product_id?: number
  property_name?: string | Record<string, string>
  value?: string | null
}

export interface MarketplaceProductEntity {
  entity_id: number
  entity_name: string
  entity_type: MarketplaceProductEntityType
}

export interface MarketplaceProduct {
  id: number
  title: string
  parent_id?: number
  description?: string
  short_description?: string
  entity?: {
    entity_id?: number
    entity_type?: MarketplaceProductEntityType
    entity_name?: string
    entity_media?: string
  }
  entity_id?: number
  entity_type?: MarketplaceProductEntityType
  regions?: any[] | null
  meta: MarketplaceMeta | null
  properties: MarketplaceProductProperty[]
  preview?: Media | null
  prices: MarketplaceProductPrice[] | null
  categories: MarketplaceCategory[]
  created_at: string
}
